import { Component, HostBinding } from '@angular/core';
import { NativeCallService } from 'src/app/services/native-call.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})
export class HomeComponent {
  readonly webAppUrl: string = window.location.origin;

  @HostBinding('class.native-ios') get nativeIosClass(): boolean {
    return this.nativeCallService.isNativeIos;
  }

  constructor(private nativeCallService: NativeCallService) {}

  get isNativeIos(): boolean {
    return this.nativeCallService.isNativeIos;
  }
}
